import { Text } from 'mondrian-react';
import { Link } from 'react-router-dom';
import styles from './styles.module.css';

function CardTabelas({ dataSet, onClick }) {
  return (
    <>
      {dataSet.map((tabela) => (
        <div className={styles.Card} key={tabela._id}>
          <div className={styles.ResultsCard}>
            <Link
              to="/result"
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => onClick(tabela)}
              className={styles.ResultsCardTitle}
            >
              {tabela._source.servico}
            </Link>
            <span
              className={`mdn-Icon-link-externo mdn-Icon--md ${styles.ResultsCardIcon}`}
            />
          </div>
          <Text body>{tabela._source.servico_descr}</Text>
        </div>
      ))}
    </>
  );
}

export default CardTabelas;
